export default { cloud_name: "dfveq6cgh", uploadPreset: "tzgbpron" };
